export enum PromotionsEnum {
  Applied,
  Potential,
  Both,
}

export enum PromotionDetailsType {
  PROMOTION = 'promotion',
  COUPON = 'coupon',
}
